<template>
  <div class="dropdown-button">
    <div class="dropdown-icon" @click="toggleDropdown" :style="getCustomStyles">
      <IconBase icon-name="actions" iconColor="#222" viewBox="0 0 512 512" width="100%" height="100%" strokeWidth="6.5px"><IconFriends /></IconBase>
    </div>
    <div v-if="requestIndicator" class="indicator"></div>
    <ConnectionNotifications
      v-if="dropDownOpen"
      :newRequestsExist="requestIndicator"
      :connectRequests="connectRequests"
      :userID="userID"
      :allLoaded="allLoaded"
      @removeRequest="removeRequest"
      @connectionsRequested="addConnections"
      @areAllLoaded="setAllLoaded"
      @setAsSeen="setAsSeen"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import messengerSocket from "@/socket/messengerSocket";

import CloseComponent from "@/mixins/CloseComponent";

import IconBase from "@/components/IconBase";
import IconFriends from "@/components/SVG/IconFriends";

import ConnectionNotifications from "./ConnectionNotifications";

export default {
  name: "ConnectionNotificationsButton",

  mixins: [CloseComponent],

  components: {
    IconBase,
    IconFriends,
    ConnectionNotifications,
  },
  data() {
    return {
      connectRequests: [],
      allLoaded: false,
    };
  },
  computed: {
    ...mapState({
      userID: (state) => state.auth.user._id,
      requestIndicator: (state) => state.indicators.connectRequests,
    }),
    dropDownOpen() {
      return this.componentOpen; /* from mixin */
    },
    getCustomStyles() {
      return "height: 23px; width: 23px; padding: 3.5px 3.5px; margin-top: 2px;";
    },
  },
  methods: {
    toggleDropdown() {
      /* wrapper for mixin */
      this.toggleComponent();
    },
    setAsSeen() {
      if (this.requestIndicator) {
        messengerSocket.setConnectionsAsSeen();
        console.log("indicator existed");
      }
    },
    addConnections(newRequests) {
      this.connectRequests = this.connectRequests.concat(newRequests);
      this.connectRequests.sort((a, b) => b.dateMS - a.dateMS);
      /* remove duplicates, since sorted, they must be side-by side if there are any */
      for (let i = this.connectRequests.length; --i > 0; ) {
        if (this.connectRequests[i].CID === this.connectRequests[i - 1].CID) {
          this.connectRequests.splice(i, 1);
        }
      }
      if (this.requestIndicator) {
        messengerSocket.setConnectionsAsSeen();
        console.log("indicator existed");
      }
    },
    setAllLoaded(newState) {
      this.allLoaded = newState;
    },
    removeRequest(request) {
      for (let i = this.connectRequests.length; --i >= 0; ) {
        if (this.connectRequests[i].CID === request.CID) {
          this.connectRequests.splice(i, 1);
        }
      }
    },
  },
};
</script>

<style scoped>
@import "./styles/DropdownButton.css";
</style>
